import React from 'react';
import { Card, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { NOILAYSOLIEU_API } from '../../../../utils/apiUrl';
import { Post } from '../../../../utils/httpProvider';
import DocumentInput from '../../../../components/document-input/DocumentInput';

const schema = yup.object().shape({
    noiLay: yup.string().required('Vui lòng nhập nơi lấy số liệu')
});

const NoiLaySoLieuAdd = ({ hoSoId, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();

    const addFunc = useMutation((value) => Post(NOILAYSOLIEU_API.CREATE, null, value, false));

    const handleCreate = (values, { setSubmitting }) => {
        const requestData = {
            hoSoNghienCuuSinhId: hoSoId,
            noiLay: values.noiLay,
            tuNgay: values.tuNgay || null,
            denNgay: values.denNgay || null,
            fileCuDiLay: values.fileCuDiLay,
            ghiChuChinhSua: values.ghiChuChinhSua,
            trangThai: 'choTiepNhan'
        };

        addFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204)) {
                    toast.success('Thêm mới thành công');
                    queryClient.invalidateQueries(['soLieuNghienCuuData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Thêm mới Nơi lấy số liệu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleCreate}
                    initialValues={{
                        noiLay: '',
                        tuNgay: '',
                        denNgay: '',
                        fileCuDiLay: '',
                        ghiChuChinhSua: ''
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Nơi lấy số liệu <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="noiLay"
                                            value={values.noiLay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Nhập nơi lấy số liệu"
                                        />
                                        {touched.noiLay && !!errors.noiLay && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.noiLay}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Từ ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="tuNgay"
                                            value={values.tuNgay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Đến ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="denNgay"
                                            value={values.denNgay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle="File cử đi lấy số liệu đính kèm"
                                            value={values.fileCuDiLay}
                                            onChangeProp={(url) => setFieldValue('fileCuDiLay', url)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="text-right mt-3">
                                <Button
                                    variant="secondary"
                                    onClick={() => setViewMode('list')}
                                    className="mr-2"
                                >
                                    Hủy
                                </Button>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? <><i className="fas fa-spinner fa-spin mr-1"></i> Thêm</> : 'Thêm'}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default NoiLaySoLieuAdd;
